import { render, staticRenderFns } from "./GlobalSignaling.vue?vue&type=template&id=67d18d0c&"
import script from "../Handler/GlobalSignaling.js?vue&type=script&lang=js&"
export * from "../Handler/GlobalSignaling.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports